import { SVGProps } from "react"

const ToptaalLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path fill="#64CAF0" d="M0 48h96v48H0V48Z" />
      <path fill="#009060" d="M0 0h96v48H0V0Z" />
      <path
        fill="#64CAF0"
        d="M74.053 17.71H61.445v-6.331h-11.51v24.144h11.51v-6.33h12.608V17.709Zm-39.498 0H21.947v11.482h12.608v6.33h11.51V11.38h-11.51v6.33Z"
      />
      <path
        fill="#009060"
        d="M17.552 76.879v-11.38h-4.054v-2.092h10.515V65.5h-4.08v11.379h-2.381Zm5.703-4.892c0-2.799 1.909-5.1 4.996-5.1 3.112 0 4.996 2.301 4.996 5.1 0 2.799-1.91 5.127-4.996 5.127-3.113 0-4.997-2.328-4.997-5.127Zm7.795 0c0-1.726-.994-3.243-2.8-3.243-1.804 0-2.798 1.517-2.798 3.243 0 1.727 1.02 3.244 2.799 3.244 1.805 0 2.799-1.517 2.799-3.244Zm6.487 3.531v5.075h-2.119V67.122h2.119v1.334a3.902 3.902 0 0 1 3.139-1.57c2.51 0 4.316 1.91 4.316 5.101 0 3.218-1.805 5.127-4.316 5.127-1.23 0-2.328-.55-3.14-1.596Zm5.284-3.53c0-1.91-1.099-3.245-2.773-3.245-.994 0-2.014.576-2.511 1.282v3.845c.47.733 1.517 1.334 2.511 1.334 1.674.027 2.773-1.307 2.773-3.217Zm5.44 4.89V65.5h-4.08v-2.093h10.516V65.5h-4.081v11.379h-2.354Zm13.132 0v-1.333c-.759.967-1.857 1.569-3.139 1.569-2.485 0-4.316-1.91-4.316-5.127 0-3.139 1.805-5.1 4.316-5.1 1.23 0 2.354.549 3.139 1.595v-1.36h2.119v9.757h-2.12Zm0-2.955v-3.846c-.47-.732-1.517-1.307-2.511-1.307-1.7 0-2.773 1.36-2.773 3.243 0 1.91 1.072 3.244 2.773 3.244.994-.026 2.066-.602 2.51-1.334Zm11.745 2.956v-1.334c-.759.967-1.857 1.569-3.14 1.569-2.484 0-4.315-1.91-4.315-5.127 0-3.139 1.805-5.1 4.316-5.1 1.23 0 2.354.549 3.139 1.595v-1.36h2.119v9.757h-2.12Zm0-2.956v-3.846c-.471-.732-1.517-1.307-2.511-1.307-1.7 0-2.773 1.36-2.773 3.243 0 1.91 1.072 3.244 2.773 3.244.994-.026 2.04-.602 2.51-1.334Zm4.865.68V63.407h2.12V74.08c0 .654.313 1.177.94 1.177.393 0 .785-.183.942-.366l.497 1.621c-.392.34-1.02.628-1.988.628-1.647-.026-2.51-.915-2.51-2.537Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h96v96H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default ToptaalLogo
